<template>
  <div
    :class="[
      'app-multiselect__field',
      {
        '--error': multiselectRef._props.status === false && !multiselectRef._props.disabled,
        '--success': multiselectRef._props.status === true && !multiselectRef._props.disabled,
        '--disabled': multiselectRef._props.disabled && multiselectRef._props.status !== false,
        '--error-disabled':
          multiselectRef._props.disabled && multiselectRef._props.status === false,
        '--focus': multiselectRef._data.isOpen,
        '--with-tags': multiselectRef._data.selectedItemsLocal.length > 0
      }
    ]"
    @click="changeOpenState"
    ref="multiselectFieldRef"
  >
    <div
      class="app-multiselect__field-content"
      ref="tagsContainer"
    >
      <MultiselectTag
        :multiselectRef="multiselectRef"
        :item="multiselectRef._props.datalist.find((x) => x.value == item)"
        :key="`multiselect-tag-${index}`"
        v-for="(item, index) in multiselectRef._data.selectedItemsLocal"
        v-if="
          multiselectRef._data.selectedItemsLocal.length && multiselectRef._props.datalist.length
        "
      />
      <span
        class="app-multiselect__field-placeholder"
        v-if="!multiselectRef._data.selectedItemsLocal.length"
        >{{ multiselectRef._props.fieldPlaceholder }}</span
      >
    </div>
    <div ref="arrowDownIconRef">
      <ArrowDownIcon
        :class="[
          'app-multiselect__arrow-down-icon',
          { '--opened': multiselectRef._data.isOpen, '--closed': !multiselectRef._data.isOpen }
        ]"
      />
    </div>
  </div>
</template>

<script>
  import MultiselectTag from './MultiselectTag.vue';
  import ArrowDownIcon from './icons/ArrowDownIcon.vue';

  export default {
    components: {
      MultiselectTag,
      ArrowDownIcon
    },
    props: {
      multiselectRef: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      changeOpenState(event) {
        const isClickInTags =
          this.$refs.multiselectFieldRef == event.target ||
          this.$refs.tagsContainer == event.target ||
          this.$refs.arrowDownIconRef == event.target ||
          this.$refs.arrowDownIconRef?.contains(event.target);

        if (
          (!isClickInTags && this.multiselectRef._data.isOpen) ||
          this.multiselectRef._props.disabled
        ) {
          return;
        }

        this.multiselectRef._data.isOpen = !this.multiselectRef._data.isOpen;
      },
      activeCarousel() {
        const slider = this.$refs.tagsContainer;
        let mouseDown = false;
        let startX, scrollLeft;

        let startDragging = function (e) {
          mouseDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        };

        let stopDragging = function () {
          mouseDown = false;
        };

        slider?.addEventListener('mousemove', (e) => {
          e.preventDefault();
          if (!mouseDown) {
            return;
          }
          const x = e.pageX - slider.offsetLeft;
          const scroll = x - startX;
          slider.scrollLeft = scrollLeft - scroll;
        });

        slider?.addEventListener('mousedown', startDragging, false);
        slider?.addEventListener('mouseup', stopDragging, false);
        slider?.addEventListener('mouseleave', stopDragging, false);
      }
    },
    mounted() {
      this.activeCarousel();
    }
  };
</script>

<style lang="scss">
  .app-multiselect__container {
    .app-multiselect__field {
      min-height: 38px;
      max-height: 38px;
      padding: 6px 13px;
      background-color: #fff;
      border: 1px solid #d8d6de;
      border-radius: 0.357rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      user-select: none;
      gap: 8px;

      &.--with-tags {
        cursor: -webkit-grab;

        &:active {
          cursor: -webkit-grabbing;
        }
      }

      &.--focus {
        border-color: #974900;
        box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
      }

      &.--success {
        border-color: #28c76f;
      }

      &.--error {
        border-color: #d32f2f;

        .app-multiselect__field-content {
          .app-multiselect__tag {
            background: #d32f2f;
          }
        }
      }

      &.--disabled {
        border-color: #7e7570;
        background-color: #eee;

        .app-multiselect__field-content {
          .app-multiselect__tag {
            background: #7e7570;
          }
        }

        .app-multiselect__arrow-down-icon {
          path {
            fill: #7e7570;
          }
        }

        .app-multiselect__field-placeholder {
          color: #7e7570 !important;
        }
      }

      &.--error-disabled {
        border-color: #d32f2f;
        background-color: #eee;

        .app-multiselect__field-content {
          .app-multiselect__tag {
            background: #7e7570;
          }
        }

        .app-multiselect__arrow-down-icon {
          path {
            fill: #7e7570;
          }
        }

        .app-multiselect__field-placeholder {
          color: #7e7570;
        }
      }

      &.--focus,
      &.--error {
        .app-multiselect__arrow-down-icon {
          path {
            fill: #4c4541;
          }
        }

        .app-multiselect__field-content {
          .app-multiselect__field-placeholder {
            color: #4c4541;
          }
        }
      }

      .app-multiselect__arrow-down-icon {
        height: 16px;
        width: 16px;

        path {
          fill: #cfc4be;
        }
      }

      .app-multiselect__field-content {
        display: flex;
        gap: 4px;
        flex: 1;
        flex-wrap: nowrap;
        overflow-x: auto;
        width: fit-content;

        .app-multiselect__field-placeholder {
          color: #cfc4be;
          font-family: Raleway;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
</style>
